import { DropdownOption } from '@/components/dropdown'
import { GeoStateType } from '@/lib/generated/graphql-types'
export const COOKIE_SALARY_FILTER_PARAMS = 'savedSalaryFilters'

export function getStateOptions(
  states: Pick<GeoStateType, 'id' | 'slug' | 'name' | 'code'>[],
) {
  return states.map((state) => ({
    id: state.id,
    slugId: state.slug,
    label: state.name,
  }))
}

export function stateAlphabeticalSorter(a: DropdownOption, b: DropdownOption) {
  if (typeof a.label !== 'string' || typeof b.label !== 'string') {
    return 0
  }
  return a.label.localeCompare(b.label)
}
